import type { TaskMember } from '@shared/types/tasks';

/** Someone still on a task (assigned, or wrote in its chat) who has left the team. */
export const FORMER_MEMBER = 'Former member';

/**
 * The member for a user id on a task. Someone no longer in the team gets a stand-in, so their chip
 * reads "Former member" (FM) rather than "Someone" and they can still be unassigned.
 */
export function taskPerson(members: TaskMember[], userId: string | null | undefined): TaskMember | undefined {
  if (!userId) return undefined;
  return (
    members.find((m) => m.user_id === userId) ?? {
      user_id: userId,
      displayname: FORMER_MEMBER,
      email: '',
      photourl: null,
      handle: null,
    }
  );
}
